module.exports = __webpack_public_path__ + "static/media/bb.7c68c6e5.jpg";